import { FC, ReactNode } from 'react'
import { InputTextType } from '../../../../../common/InputType'
import { sanitizePhoneLike } from '../../../../../util/validateContactForm'

type Props = {
  first: InputTextType
  second: InputTextType
  third?: ReactNode
  onClickSecond?: () => void
  onFocusSecond?: () => void
  onBlurSecond?: () => void
  secondRef?: (el: HTMLInputElement | null) => void
}

const PhoneLabelRow: FC<Props> = (props) => {
  const {
    first,
    second,
    third,
    onClickSecond,
    onFocusSecond,
    onBlurSecond,
    secondRef,
  } = props

  const rootClassName = third
    ? 'phoneLabelRow phoneLabelRow--withThird'
    : 'phoneLabelRow phoneLabelRow--noThird'

  return (
    <div className={rootClassName}>
      <span>
        <label htmlFor={first.id} className="d-block">
          {first.icon && <first.icon className="me-1" />}
          {first.label && `${first.label}:`}
          {first.required && (
            <span className="text-light bg-danger badge ms-1">必須</span>
          )}
        </label>
        <input
          type={first.type}
          id={first.id}
          placeholder={first.placeholder}
          autoComplete={first.autoComplete}
          style={{ width: '100%' }}
          value={first.state}
          readOnly={first.readonly}
          maxLength={first.maxLength}
          onChange={(e) => {
            const next = sanitizePhoneLike(e.target.value)
            first.setState(next)
          }}
        />
      </span>

      <span className="phoneLabelRow__spacer" aria-hidden="true" />

      <span>
        <label htmlFor={second.id} className="d-block">
          {second.icon && <second.icon className="me-1" />}
          {second.label && `${second.label}:`}
          {second.required && (
            <span className="text-light bg-danger badge ms-1">必須</span>
          )}
        </label>

        <div className="phoneLabelRow__labelInputWrap">
          <input
            ref={secondRef}
            type={second.type}
            id={second.id}
            placeholder={second.placeholder}
            autoComplete={second.autoComplete}
            style={{ width: '100%' }}
            value={second.state}
            readOnly={second.readonly}
            maxLength={second.maxLength}
            onChange={(e) => second.setState(e.target.value)}
            onClick={onClickSecond}
            onFocus={onFocusSecond}
            onBlur={onBlurSecond}
          />

          {third ? (
            <span className="phoneLabelRow__removeInLabel">{third}</span>
          ) : null}
        </div>
      </span>
    </div>
  )
}

export default PhoneLabelRow
